<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-2 title-mobile"
          primary-title
        >
          Duplicar Projeto
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-alert
            :value="true"
            type="warning"
          >
            <span class="subheading font-weight-bold">Você está prestes à duplicar: <span v-if="!projeto">{{ projetosSelected.length }} {{ projetosSelected.length > 1 ? 'projetos' : 'projeto' }}</span></span>
          </v-alert>
          <v-card v-if="projeto" class="mt-3">
            <v-card-title primary-title class="pa-2">
              <v-flex xs12>
                <div class="subheading font-weight-medium">{{ projeto.Projeto }}</div>
                <v-divider class="my-1"></v-divider>
                <div>
                  <v-icon small>event</v-icon> {{ moment(projeto.DataPrevisao).format('DD [de] MMMM [de] YYYY') }}
                </div>
                <div><v-icon small>person</v-icon> {{ projeto.Responsavel }}</div>
                <div><v-chip label dark small :color="projeto.Cor">{{ projeto.Situacao }}</v-chip></div>
              </v-flex>
            </v-card-title>
          </v-card>
          <v-text-field v-model="descricaoProjeto" hide-details label="Descrição Projeto" class="mt-3"></v-text-field>
          <v-layout :column="$vuetify.breakpoint.xsOnly">
            <v-flex xs12 md6>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="itensProjetoGrupo" label="ITENS PROJETO - GRUPO"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="itensProjetoItem" label="ITENS PROJETO - ITEM"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="tags" label="TAGS"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="colaboradores" label="COLABORADORES"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="datas" label="SETAR DATA ATUAL"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="observacoes" label="OBSERVAÇÕES"></v-checkbox>
            </v-flex>
            <v-flex xs12 md6>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="objetivo" label="OBJETIVO"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="escopo" label="ESCOPO"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="requisito" label="REQUISITO"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="risco" label="RISCO"></v-checkbox>
              <v-checkbox v-model="duplicar" hide-details color="primary" value="responsabilidade" label="RESPONSABILIDADE"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  props: ['value', 'projeto', 'loading'],
  data() {
    return {
      descricao: '',
      duplicar: []
    }
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    adiciona() {
      if (this.projeto !== null) {
        const objDuplicar = {
          projetos: [this.projeto.IdProjeto],
          descricao: this.descricao,
          itens: this.duplicar
        }
        this.$emit('duplicaProjeto', objDuplicar);
        this.duplicar = [];
      } else {
        const objDuplicar = {
          projetos: this.projetosSelected.map(projeto => projeto.IdProjeto),
          descricao: this.descricao,
          itens: this.duplicar
        }
        this.$emit('duplicaProjeto', objDuplicar);
        this.duplicar = [];
      }
    }
  },
  computed: {
    ...mapGetters(['projetosSelected']),
    descricaoProjeto: {
      // getter
      get: function () {
        if (this.projeto) {
          this.descricao = this.projeto.Projeto;
          return this.projeto.Projeto;
        } else if (this.projetosSelected.length === 1) {
          this.descricao = this.projetosSelected[0].Projeto;
          return this.projetosSelected[0].Projeto;
        } else {
          return '';
        }
      },
      set: function (value) {
        this.descricao = value;
      }
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1rem !important;
  }
}
</style>
